import React, {createContext, ReactNode, useContext, useRef} from "react";

interface TabScrollProps {
    scrollRef: React.RefObject<HTMLDivElement>;
    scrollTo: (element: Element) => void;
}

const TabScrollContext = createContext<TabScrollProps | null>(null);

export const TabScrollProvider: React.FC<{ children: ReactNode }> = ({children}) => {
    const scrollRef = useRef<HTMLDivElement>(null);

    const scrollTo = (element: Element) => {
        const container = scrollRef.current;
        if (!container) return;

        const targetRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const offset = targetRect.top - containerRect.top;

        container.scrollTo({
            top: container.scrollTop + offset,
            behavior: "smooth",
        });
    };

    return (
        <TabScrollContext.Provider
            value={{
                scrollRef,
                scrollTo,
            }}
        >
            {children}
        </TabScrollContext.Provider>
    );
};

export const useTabScroll = (): TabScrollProps => {
    const context = useContext(TabScrollContext);

    if (!context) {
        throw new Error("useTabScroll must be used within a TabScrollProvider");
    }

    return context;
};
